import {connect} from "react-redux";
import * as StudentsPeopleActions from '../../../store/actions/studentsPeopleActions';
import PeopleStudents from '../../../components/AdminPanel/People/PeopleStudents';
import * as CoursesActions from '../../../store/actions/coursesActions';

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.studentsPeople,
    ...state.courses
});

const mapDispatchToProps = (dispatch) => ({
    onLoadCourses: (uid, token) => {
        dispatch(CoursesActions.getCoursesForAdmin(uid, token));
    },
    getStudents: (token) => {
        dispatch(CoursesActions.getStudents(token));
    },

    addUserToCourse: (courseUser, token) => {
        dispatch(CoursesActions.addCourseUser(courseUser, token));
    },
    createCourseUser: (courseUser, token) => {
        dispatch(CoursesActions.createCourseUser(courseUser, token));
    },
    removeCourseUser: (id, token) => {
        dispatch(CoursesActions.removeCourseUser(id, token));
    },
    getStudentsByCourse: (courseId, token, skip) => {
        dispatch(CoursesActions.getStudentsByCourse(courseId, token, skip));
    },
    findStudentsByCourse: (where, courseId, token, skip) => {
        dispatch(CoursesActions.findStudentsByCourse(where, courseId, token, skip));
    },
    getTotalStudentCount: (courseId, token) => {
        dispatch(CoursesActions.getTotalStudentCount(courseId, token));
    },
    getStudentsData: () => {
        dispatch(StudentsPeopleActions.getStudents());
    },
    studentDelete: (id) => {
        dispatch(StudentsPeopleActions.deleteStudent(id));
    },
    editAccessStudent: (val, id) => {
        dispatch(StudentsPeopleActions.editAccess(val, id));
    },
    editReferralsStudent: (val, id) => {
        dispatch(StudentsPeopleActions.editReferrals(val, id));
    },
    editCoursesStudent: (val, id) => {
        dispatch(StudentsPeopleActions.editCourses(val, id))
    },
    editNextPaymentStudent: (val, id) => {
        dispatch(StudentsPeopleActions.editNextPayment(val, id));
    },
    updateCourseUser: (courseUser, token) => {
        dispatch(CoursesActions.updateCourseUser(courseUser, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PeopleStudents);


// WEBPACK FOOTER //
// ./src/containers/AdminPanel/People/PeopleStudentsContainer.js